import { getSubmitPayment } from "./logic/logic";
import { quickPaymentMap, regularPaymentMap } from "./map.dev";
import { sendCardPayment as sendCardPaymentQuick } from "./methods/card/index.quick";
import { sendCardPayment } from "./methods/card/index.regular";
import { sendSbpPayment as sendSbpPaymentQuick } from "./methods/fps/index.quick";
import { sendSberpayPayment as sendSberpayPaymentQuick } from "./methods/sberpay/index.quick";

// there is no regular payment handler here,
// because it is submitted in SberPayModal -> Button
quickPaymentMap.sberpay = sendSberpayPaymentQuick;

// there is not regular payment here because there is
// no submission logic for regular
quickPaymentMap.fps = sendSbpPaymentQuick;
quickPaymentMap.savedCards = sendCardPaymentQuick;
regularPaymentMap.card = sendCardPayment;
export var submitPayment = getSubmitPayment({
  regularPaymentMap: regularPaymentMap,
  quickPaymentMap: quickPaymentMap
});